import React, { PropsWithChildren } from "react";
import styled from "styled-components";

const StyledHeading = styled.div`
  padding: 20px;
  font-size: 24px;
  line-height: 1.1;
  color: #929292;
  font-weight: normal;
  border-bottom: 1px solid #cfdbe2;
  background-color: #fff;
`;

const StyledSubHeading = styled.div`
  padding: 20px;
  font-size: 20px;
  line-height: 1.1;
  color: #656565;
  font-weight: 400;
  border-bottom: 1px solid #cfdbe2;
  background-color: #fff;
`;

export function SectionHeading(props: PropsWithChildren<{}>) {
  return (
    <StyledHeading>
      {props.children}
    </StyledHeading>
  );
}

export function SectionSubHeading(props: PropsWithChildren<{}>) {
  return (
      <StyledSubHeading>
        {props.children}
      </StyledSubHeading>
  );
}